import './styles.scss'
function PurchaseCard(
    { title,
        kit_code,
        pr_code,
        purchase_quantity,
        notes,
        backgroundColor="#f5f5f5"
    }
) {
    return (
        <div className="purchase-card-container" style={{backgroundColor:backgroundColor}}>
            <div className='purchase-card-header'>
                <div className='purchase-card-header-info'>
                    <h4>{title}</h4>
                    <h2>{kit_code}</h2>
                </div>
                <div>
                    <h3>{'PR: #'+pr_code}</h3>
                </div>
            </div>
            <div className="purchase-card-details">
                <div>Quantity Purchased</div><div>:&nbsp;&nbsp;{purchase_quantity}</div>
                <div>Message</div><div>:&nbsp;&nbsp;{notes}</div>
            </div>
        </div>
    );
}

export default PurchaseCard;